import React, { useState } from 'react';
import './CourseProgressGrid.scss';
import { generateProgressTreeFromArray } from '../../utils/courseFunctions';

/**
 * Reusable grid to visualize course/lesson/step/stepItem completion.
 * Expects a normalized structure:
 * courses -> lessons -> steps -> stepItems
 * Optionally highlight a current position (lesson/step/stepItem).
 */



function CourseProgressGrid({
  courses = [],
  currentLessonIndex = null,
  currentStepIndex = null,
  currentStepItemIndex = null,
  courseRecipe = null,
  onUpdateProgress
}) {

  const [updateProgressTo, setUpdateProgressTo] = useState(null);
  
  const selectStepItem = (courseIdx, lessonIdx, stepIdx, itemIdx) => {
    setUpdateProgressTo({
      courseIndex: courseIdx,
      lessonIndex: lessonIdx,
      stepIndex: stepIdx,
      stepItemIndex: itemIdx,
    });
  }
  
  const updateProgress = async (target) => {
    try {
      const indices = [
        Number(target?.courseIndex ?? 0),
        Number(target?.lessonIndex ?? 0),
        Number(target?.stepIndex ?? 0),
        Number(target?.stepItemIndex ?? 0),
      ];
      const nextProgress = courseRecipe ? generateProgressTreeFromArray(courseRecipe, indices) : null;
      if (typeof onUpdateProgress === 'function' && nextProgress) {
        await onUpdateProgress(nextProgress);
      }
    } finally {
      setUpdateProgressTo(null);
    }
  }
  
  return (
    <div className={'courseProgressGrid'}>
      {(courses || []).map((course, courseIdx) => (
        <React.Fragment key={courseIdx}>
          {(course?.lessons || []).map((lesson, lessonIdx) => {
            const isCurrentLesson = currentLessonIndex === lessonIdx;
            return (
              <div className={'courseProgressGrid-row courseProgressGrid-lesson'} key={lessonIdx}>
                {(lesson?.steps || []).map((step, stepIdx) => {
                  const isCurrentStep = isCurrentLesson && currentStepIndex === stepIdx;
                  return (
                    <div className={'courseProgressGrid-row '} key={stepIdx}>
                      {(step?.stepItems || []).map((item, itemIdx) => {
                        const isSelected = isCurrentStep && itemIdx === currentStepItemIndex;
                        return (
                          <div
                            key={itemIdx}
                            onClick={() => selectStepItem(courseIdx, lessonIdx, stepIdx, itemIdx)}
                            className={isSelected ? 'ProgressStepItem selectedProgressStepItem' : 'ProgressStepItem'}
                          >
                            {item && item.completed ? '🟢' : '⚪'}
                          </div>
                        );
                      })}
                      {step && step.completed ? (
                        <span style={{ color: '#139c11' }}>{stepIdx}</span>
                      ) : (
                        <span style={{ color: '#cbc8c8' }}>{stepIdx}</span>
                      )}
                      &nbsp;&nbsp;
                    </div>
                  );
                })}
                🥇
                {lesson && lesson.completed ? (
                  <span style={{ color: '#139c11' }}>{lessonIdx}</span>
                ) : (
                  <span style={{ color: '#cbc8c8' }}>{lessonIdx}</span>
                )}
              </div>
            );
          })}
          {course && course.completed ? '🏆!' : '🏆'}
        </React.Fragment>
      ))}
      {updateProgressTo && (
        <> 
        <div className='updateProgressTo'>
          <div>Should update progress to:</div>
          <p>C{updateProgressTo.courseIndex},</p>
          <p>L{updateProgressTo.lessonIndex},</p>
          <p>S{updateProgressTo.stepIndex},</p>
          <p>SI{updateProgressTo.stepItemIndex}</p>

          <div className='updateProgressTo-button updateProgressTo-button-cancel' onClick={() => setUpdateProgressTo(null)}>Cancel</div>
          <div className='updateProgressTo-button' onClick={() => updateProgress(updateProgressTo)}>Update Progress</div>
        </div>

        </>
      )}
    </div>
  );
}

export default CourseProgressGrid;


